export default "__VITE_ASSET__paH8zrGV__"